import React, { PropsWithChildren } from "react";
import { InputFL, InputFLProps } from "./InputFL";
import * as Icons from "Components/Icons";
import resolvePath from "Utils/resolvePath";
import classNames from "classnames";
import { FieldValues, useFormState, useWatch } from "react-hook-form";

export const EmailInputFL = <T extends FieldValues,>({ inputClassName, ...props }: PropsWithChildren<InputFLProps<T>>) => {

   const inputValue = useWatch({
      control: props.control,
      name: props.name
   })

   const { errors, touchedFields } = useFormState({
      control: props.control,
   })

   const error = resolvePath(errors, props.name);
   const isValid = !!inputValue && !error?.message && resolvePath(touchedFields, props.name);

   return (
      <InputFL inputClassName={classNames(inputClassName, { "email-valid": isValid })}  {...props} >
         {isValid && <Icons.CheckFilled className="tc-seagrass" />}
      </InputFL>
   );
}